import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_ENDPOINTS } from "../../../../constants/endPoints";
import useApiRequest from "../../../../hook/useApiRequest";
import { ucfirst } from "../../../../utils/customFn";

const useCustomerlistUtils = () => {
  const { loading, fetchData } = useApiRequest();
  const navigate = useNavigate();
  const { customerType } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [listData, setListData] = useState({});
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
    status: "",
    customer_type: "",
  });

  console.log("customerType", customerType);
  const limit = API_ENDPOINTS?.page_limit;
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchCustomerData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_customers}`;
      const params = {
        offset: currentPage,
        limit: limit,
        search: filters.search || "",
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
        status: filters.status || "",
        customer_type: ucfirst(customerType) || "",
        verification_status: filters.verification_status || "",
      };
      const response = await fetchData(
        `${url}?${new URLSearchParams(params)}`,
        navigate
      );
      if (response) {
        setListData(response);
      }
    } finally {
    }
  };

  const handleSearch = (filtervalue) => {
    setFilters((prev) => ({ ...prev, search: filtervalue }));
  };

  const handleFilter = (filtervalue) => {
    setFilters(filtervalue);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchCustomerData();
  }, [currentPage, filters, customerType]);

  useEffect(() => {
    setCurrentPage(1);
  }, [customerType]);

  return {
    listData,
    loading,
    currentPage,
    limit,
    fetchCustomerData,
    handleSearch,
    handleFilter,
    handlePageChange,
    customerType,
  };
};

export default useCustomerlistUtils;
